import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { clearException, popException, closeException } from 'actions/exceptions/clearException';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from 'components/Common/Buttons';

class Notifications extends Component {
  static clearTimer;

  componentDidMount() {
    this.setTimer();
  }

  componentDidUpdate() {
    this.setTimer();
  }

  setTimer() {
    const { dispatch, notifs } = this.props;

    Notifications.resizeTimer = clearInterval(Notifications.resizeTimer);
    Notifications.resizeTimer = null;

    if (dispatch != null && notifs != null && notifs.length > 0) {
      Notifications.resizeTimer = setInterval(() => {
        this.pop();
      }, 3000, this);
    }
  }

  pop() {
    const { dispatch } = this.props;
    dispatch(closeException(0));
    setTimeout(() => { dispatch(popException()); this.setTimer(); }, 900);
  }

  clear(exception, index) {
    const { dispatch } = this.props;
    dispatch(closeException(index));
    setTimeout(() => { dispatch(clearException(exception)); this.setTimer(); }, 900);
  }

  render() {
    const { notifs } = this.props;

    return (
      notifs != null && notifs.length > 0 && <section className="container notifs">
        <div className="row">
          <div className="col">
            { notifs.map((item, i) => <div key={ item.id } className={ `notif error ${ item.closing ? 'closing' : '' }` }>
              { `${ item.code } - ${ item.message }`}
              <Button text="" value="close" className="close" onClick={ () => this.clear(item, i) }><FontAwesomeIcon icon="times" /></Button>
            </div>)}
          </div>
        </div>
      </section>
    );
  }
}

Notifications.propTypes = {
  dispatch: PropTypes.func.isRequired,
  notifs: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.number,
    code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    message: PropTypes.string,
    adding: PropTypes.bool,
    closing: PropTypes.bool
  }))
};

Notifications.defaultProps = {
  notifs: []
};

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state) {
  const {
    exceptions: { items }
  } = state;

  return {
    notifs: items
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Notifications);
